<div class="flex flex-col w-full h-full max-h-[100vh]">
  <!-- Loading -->
  <ng-container *ngIf="!isInitialized; else initializedEditor">
    <mat-spinner class="m-auto grayscale scale-50 opacity-50"></mat-spinner>
  </ng-container>

  <!-- Loaded -->
  <ng-template #initializedEditor>
    <!-- Desktop -->
    <div class="flex flex-col h-full">
      <!-- Cover -->
      <cover
        *ngIf="showCover"
        (onClose)="showCover = false"
        class="h-full absolute"
        [initialState]="coverInitialState"
      ></cover>

      <!-- Ribbons -->
      <ribbon-for-debug
        *ngIf="environment.isDevelopmentBuild()"
      ></ribbon-for-debug>
      <ribbon-for-demo
        *ngIf="showDemoRibbon"
        (onLearnMoreClick)="openHero()"
        (onOpenLoginClick)="openLogin()"
        (onCreateAccountClick)="openSignup()"
      ></ribbon-for-demo>
      <ribbon-for-email-verification
        *ngIf="showEmailVerificationRibbon"
        (onEmailChangeClick)="openSettings('account')"
      ></ribbon-for-email-verification>

      <div
        class="flex flex-row items-stretch w-full h-full overflow-hidden grow"
      >
        <mat-sidenav-container class="w-full">
          <mat-sidenav
            [mode]="browserService.isOnMobile() ? 'over' : 'side'"
            [opened]="!browserService.isOnMobile()"
            [disableClose]="true"
            #sidenav
          >
            <sidebar
              #sidebar
              [tag]="tagFullPath"
              [detailedTags]="detailedTags"
              [tagNodes]="tagNodes"
              (onAllEntriesClick)="openAllEntries()"
              (onOpenPlannerClick)="openPlanner()"
              (onOpenSettingsClick)="openSettings()"
              (onTagClick)="
                openEntriesWithTag(
                  $event.tag.fullPath,
                  $event.period,
                  $event.preventSidebarClose
                )
              "
              class="grow-[1] !bg-zinc-800 text-slate-400 w-full h-full"
              mwlResizable
            ></sidebar>
          </mat-sidenav>
          <mat-sidenav-content>
            <mobile-planner
              [hidden]="mainState !== 'mobile-planner'"
              (onHamburgerClick)="sidenav.toggle()"
              (onOpenSettingsForPrefundPro)="openSettings('prefund_pro')"
              [detailedTags]="detailedTags"
              [detailedArchivedTags]="detailedArchivedTags"
            ></mobile-planner>

            <!-- Mobile Adder -->
            <mobile-adder
              #mobileAdder
              [ngClass]="{
                'hidden-mobile-adder': mainState !== 'mobile-adder'
              }"
              [detailedTags]="detailedTags"
              [tag]="tagFullPath"
              (onSubmit)="showEntries()"
              (onHamburgerClick)="mainState = 'entries'"
            ></mobile-adder>

            <mobile-settings
              [hidden]="mainState !== 'mobile-settings'"
              [(state)]="mobileSettingsState"
              (onOpenLoginClick)="openLogin()"
              (onHamburgerClick)="sidenav.toggle()"
            ></mobile-settings>

            <!-- Entries -->
            <entries
              [ngClass]="{ '!hidden': mainState !== 'entries' }"
              [detailedEntries]="detailedEntries"
              [periodFilter]="periodFilter"
              [plannedExpenditure]="tagPlannedExpenditure"
              [tagsWithSummaryDetails]="
                detailedTags.concat(detailedArchivedTags)
              "
              [tag]="tagFullPath"
              class="grow-[7] shrink-0"
              mwlResizable
              (onOpenAdderClick)="openAdder()"
              (onOpenPlannerClick)="openPlanner($event)"
              (onDelete)="deleteEntry($event)"
              (onEdit)="editEntry($event)"
              (onHamburgerClick)="sidenav.toggle()"
            ></entries>
          </mat-sidenav-content>
        </mat-sidenav-container>
        <!-- Sidebar -->
      </div>
    </div>
  </ng-template>
</div>
